import script from "./AdminModerationLog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminModerationLog.vue?vue&type=script&setup=true&lang=js"

import "./AdminModerationLog.vue?vue&type=style&index=0&id=5770a143&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5770a143"]])

export default __exports__